import { render, staticRenderFns } from "./DataCardMultiple.vue?vue&type=template&id=200f3aa0&scoped=true&"
import script from "./DataCardMultiple.vue?vue&type=script&lang=js&"
export * from "./DataCardMultiple.vue?vue&type=script&lang=js&"
import style0 from "./DataCardMultiple.vue?vue&type=style&index=0&id=200f3aa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "200f3aa0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
